import React, { useState, useEffect } from "react";
import CustomInput from "../../../components/common/CustomInput/CustomInput";
import CustomTable from "../../../components/common/CustomTable";

import { useDispatch, useSelector } from "react-redux";
import { listUserAsync } from "../../../redux/features/listUserSlice";
import { backdropLoadingAction } from "../../../redux/features/helperSlice";

import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import BodyHeader from "../../../components/common/CommonBodyHeader";
import { BsPencilSquare } from "react-icons/bs";
import CustomToggleSwitch from "../../../components/common/CustomToggle";
import { changeStatus } from "../../../Api/dispatch/user-dispatch";

export default function UserList() {
   const dispatch = useDispatch();
   const navigate = useNavigate();
   const userList = useSelector((state) => state.listUser.user);
   const [userRecords, setUserRecords] = useState([]);
   const [isActiveLoading, setIsActiveLoading] = useState({
      id: "",
      status: false,
   });

   useEffect(() => {
      dispatch(backdropLoadingAction(true));
      dispatch(
         listUserAsync({
            done: () => {
               dispatch(backdropLoadingAction(false));
            },
            err: (error) => {
               toast.error(error);
               dispatch(backdropLoadingAction(false));
            },
         })
      );
   }, []);

   useEffect(() => {
      if (userList) {
         setUserRecords(userList);
      }
   }, [userList]);

   // Handle active inactive
   const handleActiveInactive = (user) => {
      setIsActiveLoading({ id: user?.id, status: true });
      changeStatus({ id: user?.id, status: user?.is_active === "1" ? "0" : "1" })
         .then((res) => {
            setIsActiveLoading({ id: user?.id, status: false });
            dispatch(listUserAsync({}));
            toast.success(
               `user ${user?.is_active === "1" ? "deactivated" : "activated"}`
            );
         })
         .catch((error) => {
            setIsActiveLoading({ id: user?.id, status: false });
            toast.error(
               `Failed to ${user?.is_active === "1" ? "deactivate" : "activate"} user`
            );
         });
   };

   const columns = [
      {
         name: "User Name",
         selector: (row) => row.name,
         sortable: true,
      },
      {
         name: "Mobile No",
         selector: (row) => row.mobile,
      },
      {
         name: "User Type",
         selector: (row) => row.role_name,
         sortable: true,
      },
      {
         name: "Action",
         width: "9rem",
         selector: (row) => {
            return (
               <div className="d-flex align-items-center">
                  <button
                     className="btn"
                     onClick={() => navigate(`/user/update-user/${row?.id}`)}
                  >
                     <BsPencilSquare
                        className="text-primary"
                        style={{ height: "1.5rem", width: "1.5rem" }}
                     />
                  </button>
                  <CustomToggleSwitch
                     checked={row?.is_active === "1"}
                     onChange={() => handleActiveInactive(row)}
                     isLoading={isActiveLoading.id === row?.id && isActiveLoading.status}
                  />
               </div>
            );
         },
      },
   ];

   const handleFilter = (e) => {
      const { value } = e.target;
      const searchText = value.toLowerCase();
      const newData = userList?.filter((item) => {
         return item?.name?.toLowerCase().includes(searchText);
      });
      setUserRecords(newData);
   };

   return (
      <>
         <BodyHeader title="User Master List" />
         <div className="px-3">
            <div className="d-flex justify-content-start">
               <CustomInput
                  inputType="text"
                  placeholder="Search..."
                  id="search"
                  onChange={handleFilter}
               />
            </div>
            <CustomTable columns={columns} data={userRecords} />
         </div>
      </>
   );
}
